export function resolveEntryGuideItemProject(item) {
  if (!item) return null;

  return (
    item.project
    || item.document_item?.project
    || item.purchase_order_item?.project
    || item.requirement_item?.project
    || null
  );
}

export function formatEntryGuideItemProject(item) {
  const project = resolveEntryGuideItemProject(item);
  if (!project) return '—';

  const code = project.code || '';
  const name = project.name || '';

  if (code && name) return `${code} - ${name}`;
  return code || name || '—';
}
